import { Component } from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../Lightbox';
import { urlReformatPhotos } from '../../../utils/lightbox_helpers';
import CustomProvider from 'components/CustomProvider';

// This lightbox is used to be rendered when the photo collection, only use when you cannot render a lightbox from a react component.
class RemoteLightbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      activeIndex: null,
      photos: props.photos.map(photo => {
        return photo.photo;
      })
    };
  }

  componentDidMount() {
    window.document.addEventListener('openRemoteLightbox', this.openLightbox);
  }

  componentWillUnmount() {
    this.setState({ isOpen: false, activeIndex: null });
    window.document.removeEventListener('openRemoteLightbox', this.openLightbox);
  }

  handleCloseRequest = () => {
    this.setState({ isOpen: false, activeIndex: null });
  };

  openLightbox = data => {
    const { photoId } = data.detail;
    const activeIndex = this.state.photos.findIndex(photo => {
      return photo.id === photoId;
    });

    this.setState({ activeIndex, isOpen: true });
  };

  getLightboxProps() {
    const images = urlReformatPhotos(this.state.photos);
    const activePhoto = this.state.photos[this.state.activeIndex];
    return {
      isOpen: this.state.isOpen,
      images,
      handleCloseRequest: this.handleCloseRequest,
      startingIndex: this.state.activeIndex,
      trailId: activePhoto.trail_id,
      mapId: activePhoto.map_id
    };
  }

  renderLightbox() {
    if (!this.state.isOpen) {
      return;
    }

    return <Lightbox {...this.getLightboxProps()} />;
  }

  render() {
    return <CustomProvider>{this.renderLightbox()}</CustomProvider>;
  }
}

RemoteLightbox.propTypes = {
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      photo: PropTypes.shape({
        id: PropTypes.number,
        photo_hash: PropTypes.string,
        trail_id: PropTypes.number,
        map_id: PropTypes.number
      })
    })
  )
};

export default RemoteLightbox;
